<template>
  <div>{{ value.val }}</div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { IdentifierValue } from '@/types';
import { getDefaultIdentifier } from '@/utils';

export default defineComponent({
  name: 'ContactsTableDataCellIdentifierObject',
  props: {
    value: {
      type: Object as PropType<IdentifierValue>,
      required: false,
      default: () => getDefaultIdentifier(),
    },
  },
});
</script>
